// libs
import React, { memo, useContext, useCallback } from "react";

// defs
import { Analytics, BillResponseWidget } from "@payment-client/interfaces/Checkout";

// dls
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";

// styled
import { Content } from "./styled";

// widgets
import BillLineItem from "./widgets/BillLineItem";
import TotalPayableItem from "./widgets/TotalPayable";

// contexts
import { AnalyticsContext } from "@swiggy-private/checkout-core";

// helpers
import { sendEMIWidgetImpressionEvent } from "@payment-client/components/show-payments/components/review-bill-details-renderer/helpers/analytics";

interface BillDetailsProps {
    bill: BillResponseWidget;
}

const BillDetails: React.FC<BillDetailsProps> = ({ bill }) => {
    const { impressionEvent } = useContext(AnalyticsContext);

    const captureImpression = useCallback(
        (payload?: Analytics) => {
            sendEMIWidgetImpressionEvent(impressionEvent, payload);
        },
        [impressionEvent],
    );

    if (!bill) {
        return null;
    }

    return (
        <CardContainer
            elevation
            stroke="border_Tertiary"
            cornerRadius="medium"
            customPadding={{ left: 16, right: 16, top: 16, bottom: 20 }}
        >
            {bill.data.map((ele, index) => {
                return (
                    <Content key={index}>
                        {ele.lineItems?.map((lineItem, ind) => (
                            <BillLineItem
                                lineItem={lineItem}
                                key={`row-${index}-${ind}`}
                                captureImpression={captureImpression}
                            />
                        ))}
                        {ele.toPay && <TotalPayableItem toPayItem={ele.toPay} captureImpression={captureImpression} />}
                    </Content>
                );
            })}
        </CardContainer>
    );
};

export default memo(BillDetails);
